import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { Row, Space, Button } from 'antd';
import useMountEffect from '@restart/hooks/useMountEffect';
import commaNumber from 'comma-number';
import dayjs from 'dayjs';

import styles from './index.module.scss';
import { downloadExcelFile } from '../../utils/FileDownloader';
import { getCustomerStatus } from '../../utils/CodeMapper';
import { getDisplayName } from '../../utils/getDisplayName';
import API from '../../helpers/API';
import { UnitTable } from '../../components/ui';
import { buildCustomerColumns, CUSTOMER_TABLE_SCROLL_X } from './customerTable';

const cx = classNames.bind(styles);

const Page = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState();

  useMountEffect(() => {
    API.get('/customers').then(({ success, data }) => {
      if (success) {
        setCustomers(data.customers);
      }
    });
  });

  const download = () => {
    const records = customers.map((customer) => ({
      A: customer.name,
      B: customer.tel || '-',
      C: `${customer.address || ''} ${customer.addressDetail || ''}`.trim() || '-',
      D: getCustomerStatus(customer.status),
      E: dayjs(customer.createdAt).format('YYYY-MM-DD HH:mm:ss'),
      F: getDisplayName(customer.createdBy),
      G: dayjs(customer.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
      H: getDisplayName(customer.updatedBy),
    }));

    downloadExcelFile(
      [
        {
          A: '고객사명',
          B: '대표 연락처',
          C: '주소',
          D: '상태',
          E: '등록일시',
          F: '등록자',
          G: '수정일시',
          H: '수정자',
        },
      ],
      records,
      `고객사내역-${dayjs().format('YYYYMMDDHHmmss')}`,
    );
  };

  if (customers === undefined) return;

  return (
    <div className={cx('container')}>
      <h1 className={cx('title')}>고객사 내역</h1>
      <Row align="middle" justify="space-between" className={cx('controlbar')}>
        <div className={cx('total')}>{`총 ${commaNumber(customers.length)}건`}</div>
        <Space>
          <Button type="primary" onClick={download}>
            엑셀 다운로드
          </Button>
          <Button type="primary" onClick={() => navigate('/customers/new')}>
            신규
          </Button>
        </Space>
      </Row>
      <UnitTable
        columns={buildCustomerColumns()}
        dataSource={customers}
        rowKey={(record) => record.rid}
        virtual={false}
        sticky={true}
        scroll={{ x: CUSTOMER_TABLE_SCROLL_X }}
        onRow={(record) => ({
          onClick: () => navigate(`/customers/${record.rid}`),
        })}
      />
    </div>
  );
};

export default Page;
